import { MenuItemsType, DropdownMenuItemType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    icon: 'Swap',
    href: '/swap',
    showItemsOnMobile: false,
    items: [
      { label: t('Exchange'), href: '/swap' },
      { label: t('Liquidity'), href: '/liquidity' },
      { label: t('Import Pool'), href: '/find' },
    ],
  },
  {
    label: t('Earn'),
    icon: 'Earn',
    href: '/farms',
    items: [
      { label: t('Farms'), href: '/farms' },
      { label: t('Pools'), href: '/pools' },
    ],
  },
  {
    label: t('Charts'),
    icon: 'Info',
    href: '/info',
    showItemsOnMobile: false,
    items: [{ label: t('Charts'), href: '/info' }],
  },
  {
    label: t('Chains'),
    icon: 'Binance',
    href: '#',
    hideSubNav: true,
    items: [
      {
        label: t('BESC Hyperchain'),
        href: 'https://bescswap.com',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('BNB Smart Chain'),
        href: 'https://bscbescswap.com',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Ethereum'),
        href: 'https://ethbescswap.com',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  {
    label: t('More'),
    icon: 'More',
    href: '#',
    hideSubNav: true,
    items: [
      {
        label: t('Bridge'),
        href: 'https://wbescbridge.com',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Website'),
        href: 'https://bescfinancial.com',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
]

export default config
